import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import activityLogRoutes from 'modules/activityLog/common/routing/routes'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const CourseLogDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityLogCourseLogDetails" */ 'modules/activityLog/details/CourseLogDetails/pages/CourseLogDetails'
    )
)

const CourseLogDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:courseId`} component={CourseLogDetails} />
      <Redirect path='*' to={activityLogRoutes.root} />
    </Switch>
  </Suspense>
)

export default CourseLogDetailsRouting
